import moment from "moment";
import jwt from "json-web-token";
// import LobConstants from "../constants/LobConstants";
import serverCredintials from "../constants/serverCredintials";
import { default as Dsrservices } from "./services/DsrServices";
import { default as MasterServices } from "./services/MasterServices";
import { default as GpwisJobservices } from "./services/GpwisJobServices";
import SftoJobServices, {
  default as SftoJobservices,
} from "./services/SftoJobServices";
import { default as DamageWagonService } from "./services/DamageWagonService";
import { default as TrackRakeServices } from "./services/TrackRakeServices";
import { default as SapTransactionServices } from "./services/SapTransactionServices";
import { default as RakeMaintenanceService } from "./services/RakeMaintenanceService";
import { default as RakeInductionServices } from "./services/RakeInductionServices";
import { default as dmsFileUploadServices } from "./services/DMSFileUploadServices";
import { default as ReportServices } from "./services/ReportServices";
import { getLoggedInSessionEmail } from "./commonMethods";
import { default as AccountServices } from "./services/AccountServices";
import WagonMaintenanceService from "./services/WagonMaintenanceService";
import { default as GeneralJobServices } from "./services/GeneralJobServices";
import SFTOReconciliationServices from "./services/SFTOReconciliationServices";

const SERVICE_URL = serverCredintials.BuildURL.getServiceURL();
const EMAIL_SERVICE = serverCredintials.BuildURL.getEmailServiceEndpoint();

const CONFIG_HEADERS = {
  userid: 1,
  // token:
  //   "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE1ODcwMTU0OTksImV4cCI6MTYxODU1MTU2MywiYXVkIjoibXNyIGNvc21vcyIsInN1YiI6InBhdmFuQGV4YW1wbGUuY29tIiwiR2l2ZW5OYW1lIjoiQ29zbW9zIiwiU3VybmFtZSI6Im1zciIsIkVtYWlsIjoicGF2YW5AZXhhbXBsZS5jb20iLCJSb2xlIjpbInJhdmkiLCJzdXJlc2giXX0.fftTinP-0dPxBXAc2DiickrvE5h24yMiXkEdIu60jWE",
  token: sessionStorage.getItem("token"),
  user_email: getLoggedInSessionEmail(),
  updated_by: getLoggedInSessionEmail(),
};

let secret = "TMILL_LOB";

const getEncodedUserPw = (saps = null) => {
  let payload = {
    saps,
    secret,
    expiry: new Date(Date.now() + 60 * 1000),
  };

  let encode_user_pw = jwt.encode(
    secret,
    payload,
    function (err1, encodedUser) {
      return encodedUser;
    }
  );
  return encode_user_pw;
};

export async function listDsr(queryparams = null) {
  return await Dsrservices.listDsrService(
    SERVICE_URL + "/master/dailystatusreport",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function downloadDsrReport() {
  let filename =
    "DSR_List_" + moment(Date.now()).format("DD-MM-YYYY") + ".xlsx";
  return await Dsrservices.downloadDsrReportService(
    SERVICE_URL + "/master/exportdailystatusreport",
    filename,
    CONFIG_HEADERS
  );
}

//Master Data APIs
export async function listCustomers() {
  return await MasterServices.listCustomers(
    SERVICE_URL + "/master/customers",
    CONFIG_HEADERS
  );
}

export async function getUserToken(postedData) {
  // debugger;
  CONFIG_HEADERS.token && delete CONFIG_HEADERS.token;
  CONFIG_HEADERS.user_email = postedData.user_email;
  return await SftoJobServices.createJobService(
    SERVICE_URL + "/userPrivileges",
    postedData,
    CONFIG_HEADERS
  );
}

export async function listCommonDropdownValues(queryparams = null) {
  return await Dsrservices.listDsrService(
    SERVICE_URL + "/getcommondropdowns",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function listOriginDestinations() {
  return await MasterServices.listOrignDestinations(
    SERVICE_URL + "/master/origindestinations",
    CONFIG_HEADERS
  );
}
export async function listGpwisStatus() {
  return await MasterServices.listGpwisStatus(
    SERVICE_URL + "/master/gpwisstatus",
    CONFIG_HEADERS
  );
}
export async function listSftoActiveRakes() {
  let param = {
    scheme_type: "sfto",
  };

  return await MasterServices.listSftoActiveRakes(
    SERVICE_URL + "/master/activerakes",
    param,
    CONFIG_HEADERS
  );
}
export async function listGpwisActiveRakes() {
  let param = {
    scheme_type: "gpwis",
  };
  return await MasterServices.listGpwisActiveRakes(
    SERVICE_URL + "/master/activerakes",
    param,
    CONFIG_HEADERS
  );
}
//End Of Master data APIs

// Rakedetention Reports APIs
export async function rakeDetentionReports(param = null) {
  return await ReportServices.getReport(
    SERVICE_URL + "/rakedetention/report",
    param,
    CONFIG_HEADERS
  );
}

export async function tonnageReports(param = null) {
  return await ReportServices.getReport(
    SERVICE_URL + "/tonnage/report",
    param,
    CONFIG_HEADERS
  );
}

export async function idelWeightReports(param = null) {
  return await ReportServices.getReport(
    SERVICE_URL + "/idelweight/report",
    param,
    CONFIG_HEADERS
  );
}

// End of Rakedetention Reports APIs

// monthly/daily report OR Executive dashboard
export async function postMonthlyOrDailyReport(postdata) {
  return await DamageWagonService.saveDamageWagonService(
    SERVICE_URL + "/dashboard/positionreportdashboard",
    postdata,
    CONFIG_HEADERS
  );
}

export async function getMonthlyOrDailyReport(param = null) {
  return await ReportServices.getDailyPositionReport(
    SERVICE_URL + "/dashboard/positionreportdashboard",
    param,
    CONFIG_HEADERS
  );
}

export async function filterMonthlyOrDailyReport(postdata) {
  return await ReportServices.getDailyPositionReport(
    SERVICE_URL + "/dashboard/positionreportdashboard",
    postdata,
    CONFIG_HEADERS
  );
}

export async function getLobDataForDefaultData(postdata) {
  return await ReportServices.getDailyPositionReport(
    SERVICE_URL + "/master/dailypositionreportdata",
    postdata,
    CONFIG_HEADERS
  );
}

export async function getExecutiveDashboardData(param = null, psd_token) {
  CONFIG_HEADERS.token = psd_token
    ? psd_token
    : sessionStorage.getItem("token");

  return await ReportServices.getDailyPositionReport(
    SERVICE_URL + "/dashboard/executivedashboard",
    param,
    CONFIG_HEADERS
  );
}

// Consolidated Invoice APIs

export async function getConsolidatedData(param = null) {
  return await ReportServices.getDailyPositionReport(
    SERVICE_URL + "/consolidatedinvoice",
    param,
    CONFIG_HEADERS
  );
}

export async function consolidatedInvoiceSapTransaction(
  postdata = null,
  sapCredintials = null
) {
  // CONFIG_HEADERS.sap_user_name = sapCredintials.username;
  // CONFIG_HEADERS.sap_password = sapCredintials.password;
  CONFIG_HEADERS.sap_name_pw = await getEncodedUserPw(sapCredintials);
  return await SapTransactionServices.createSFTOIOService(
    SERVICE_URL + "/saptransaction",
    postdata,
    CONFIG_HEADERS
  );
}

export async function getConsolidatedInvoiceOptions(param = null) {
  return await ReportServices.getDailyPositionReport(
    SERVICE_URL + "/allinvoiceList",
    param,
    CONFIG_HEADERS
  );
}

export async function downloadConsolidatedInvoiceDetails(postdata = null) {
  let filename =
    "consolidated_invoice" + moment(Date.now()).format("DD-MM-YYYY") + ".xlsx";
  return await SftoJobservices.downloadConsolidatedInvoicePdf(
    SERVICE_URL + `/printannexureexcel`,
    filename,
    CONFIG_HEADERS,
    postdata
  );
}

export async function downloadMgtInvoiceDetails(postdata = null) {
  let filename =
    "mgt_invoice" + moment(Date.now()).format("DD-MM-YYYY") + ".xlsx";
  return await SftoJobservices.downloadConsolidatedInvoicePdf(
    SERVICE_URL + `/printannexureexcel`,
    filename,
    CONFIG_HEADERS,
    postdata
  );
}

//GPWIS services

export async function gpwisCustomerWolist(queryparams = null) {
  return await GpwisJobservices.customerWOListService(
    SERVICE_URL + "/gpwis/customerwo",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function gpwisCircuitlist() {
  return await GpwisJobservices.circuitListService(
    SERVICE_URL + "/listview/gpwiscircuitnames",
    CONFIG_HEADERS
  );
}

export async function gpwisCreateJob(postdata = null, job_type = "L") {
  if (job_type === "L") {
    return await GpwisJobservices.createJobService(
      SERVICE_URL + "/gpwis/jobheader",
      postdata,
      CONFIG_HEADERS
    );
  }
  if (job_type === "E")
    return await GpwisJobservices.createEmptyJobService(
      SERVICE_URL + "/gpwis/jobheader/empty",
      postdata,
      CONFIG_HEADERS
    );
  if (job_type === "M")
    return await GpwisJobservices.createMaintenanceJobService(
      SERVICE_URL + "/gpwis/jobheader/maintenance",
      postdata,
      CONFIG_HEADERS
    );
  if (job_type === "IR")
    return await GpwisJobservices.createMaintenanceJobService(
      SERVICE_URL + "/gpwis/jobheader/ir",
      postdata,
      CONFIG_HEADERS
    );
}

export async function jobInvoiceDetails(
  postdata = null,
  sapCredintials = null
) {
  // CONFIG_HEADERS.sap_user_name = sapCredintials?.username;
  // CONFIG_HEADERS.sap_password = sapCredintials?.password;
  CONFIG_HEADERS.sap_name_pw = await getEncodedUserPw(sapCredintials);
  return await GpwisJobservices.createJobService(
    SERVICE_URL + "/invoice/jobheader",
    postdata,
    CONFIG_HEADERS
  );
}

export async function searchGpwisJoblist(queryparams = null) {
  return await GpwisJobservices.searchJobService(
    SERVICE_URL + "/listview/gpwiscircuitjobs",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function activeGpwisJobsList() {
  return await GpwisJobservices.activeGpwisJobsListService(
    SERVICE_URL + "/listview/activegpwisjobs",
    CONFIG_HEADERS
  );
}
export async function gpwisCustomerJobsList(queryparams = null) {
  return await GpwisJobservices.customerJobsListService(
    SERVICE_URL + "/listview/customergpwisjobs",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function circuitCyleActiveJobs(queryparams = null) {
  return await GpwisJobservices.circuitCyleActiveJobsService(
    SERVICE_URL + "/gpwis/circuitcyclejobs",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function approveGpwisJob(postdata = null) {
  return await GpwisJobservices.approveJobService(
    SERVICE_URL + "/gpwis/approvejob",
    null,
    postdata,
    CONFIG_HEADERS
  );
}

export async function gpwisJobRakedetails(postdata = null) {
  return await GpwisJobservices.gpwisJobRakedetailsService(
    SERVICE_URL + "/gpwis/jobrakedetails",
    null,
    postdata,
    CONFIG_HEADERS
  );
}

export async function getGpwisJobHeader(queryparams = null) {
  return await GpwisJobservices.getGpwisJobHeaderService(
    SERVICE_URL + "/gpwis/jobheader",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getGpwisJobLoadingDetails(queryparams = null) {
  return await GpwisJobservices.getGpwisJobLoadingDetailsService(
    SERVICE_URL + "/gpwis/jobloadingdetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getGpwisJobUnloadingDetails(queryparams = null) {
  return await GpwisJobservices.getGpwisJobUnloadingDetailsService(
    SERVICE_URL + "/gpwis/jobunloadingdetails",
    queryparams,
    CONFIG_HEADERS
  );
}
//End of GPWIS Services
// export default {
//   listDsr, listCustomers, listOriginDestinations, listGpwisStatus, listSftoActiveRakes, listGpwisActiveRakes, gpwisCustomerWolist, gpwisCircuitlist, gpwisCreateJob, commodityList,
//   gpwisJoblist, SftoCustomerWolist
// };

// SFTO Services
export async function SftoCustomerWolist(queryparams = null) {
  return await SftoJobservices.customerWOList(
    SERVICE_URL + "/listview/sftocontracts",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function SftoCustomerWoDetails(queryparams = null) {
  return await SftoJobservices.customerWODetails(
    SERVICE_URL + "/listview/sftocontractdetails",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function ShipToPartyDetails(postdata = null) {
  return await GpwisJobservices.createJobService(
    SERVICE_URL + "/masters/shiptoparty",
    postdata,
    CONFIG_HEADERS
  );
}
export async function VendorDetails(queryparams = null) {
  return await SftoJobservices.customerWODetails(
    SERVICE_URL + "/masters/vendors",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function POVendorDetails(queryparams = null) {
  return await SftoJobservices.customerWODetails(
    SERVICE_URL + "/masters/povendors",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function SftoCustomerWoRouteDetails(queryparams = null) {
  return await SftoJobservices.customerWORouteDetails(
    SERVICE_URL + "/listview/sftocontractroutedetails",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function SftoRoutelist(queryparams = null) {
  return await SftoJobservices.sftoRouteDetails(
    SERVICE_URL + "/listview/sftoroutes",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function SftoRakeDetails(queryparams = null) {
  return await SftoJobservices.sftoRakeDetailslist(
    SERVICE_URL + "/listview/sftorakedetails",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function sftoCreateJob(postdata = null, job_type = "L") {
  if (job_type === "L")
    return await SftoJobservices.createJobService(
      SERVICE_URL + "/sfto/jobheader",
      postdata,
      CONFIG_HEADERS
    );
  if (job_type === "E")
    return await SftoJobservices.createEmptyJobService(
      SERVICE_URL + "/sfto/jobheader/empty",
      postdata,
      CONFIG_HEADERS
    );
  if (job_type === "M")
    return await SftoJobservices.createEmptyJobService(
      SERVICE_URL + "/sfto/jobheader/maintenance",
      postdata,
      CONFIG_HEADERS
    );
  if (job_type === "IR")
    return await SftoJobservices.createIRJobService(
      SERVICE_URL + "/sfto/jobheader/ir",
      postdata,
      CONFIG_HEADERS
    );
}

export async function sftoUpdateJob(postdata = null, job_type = "E") {
  if (job_type === "E")
    return await SftoJobservices.updateEmptyJobService(
      SERVICE_URL + "/sfto/jobheader/empty",
      postdata,
      CONFIG_HEADERS
    );
  if (job_type === "M")
    return await SftoJobservices.updateMaintainanceJobService(
      SERVICE_URL + "/sfto/jobheader/maintenance",
      postdata,
      CONFIG_HEADERS
    );
  if (job_type === "IR")
    return await SftoJobservices.updateIRJobService(
      SERVICE_URL + "/sfto/jobheader/ir",
      postdata,
      CONFIG_HEADERS
    );
}
export async function sftojobheaderdetails(queryparams = null) {
  return await SftoJobservices.sftojobheaderDetailslist(
    SERVICE_URL + "/listviews/sftojobheader",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function sftojobheaderdetailsbyjobid(queryparams = null) {
  return await SftoJobservices.sftojobheaderDetailslistbyjobid(
    SERVICE_URL + "/sfto/jobheaderdetails",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function sftoOriginDetailsbyjobid(queryparams = null) {
  return await SftoJobservices.sftoOriginDetailsbyjobidService(
    SERVICE_URL + "/sfto/getindentorigindetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function approveSftoJob(postdata = null) {
  return await SftoJobservices.approveJobService(
    SERVICE_URL + "/sfto/approvejob",
    null,
    postdata,
    CONFIG_HEADERS
  );
}
//Mail Service
export async function sendEmail(queryparams = null, postdata = null) {
  return await MasterServices.sendEmailService(
    EMAIL_SERVICE + "/common/email/sendtempletemail",
    queryparams,
    postdata,
    CONFIG_HEADERS
  );
}

export async function gpwisSaveJobRakeDetails(params = null, postdata = null) {
  return await GpwisJobservices.gpwisSaveJobRakeDetailsService(
    SERVICE_URL + "/gpwis/jobrakedetails",
    params,
    postdata,
    CONFIG_HEADERS
  );
}

export async function gpwisSaveJobRRDetails(params = null, postdata = null) {
  return await GpwisJobservices.gpwisSaveJobRRDetailsService(
    SERVICE_URL + "/gpwis/jobrrdetails",
    params,
    postdata,
    CONFIG_HEADERS
  );
}

export async function gpwisSaveJobLoadingDetails(
  params = null,
  postdata = null
) {
  return await GpwisJobservices.gpwisSaveJobLoadingDetailsService(
    SERVICE_URL + "/gpwis/jobloadingdetails",
    params,
    postdata,
    CONFIG_HEADERS
  );
}

export async function gpwisSaveJobUnloadingDetails(
  params = null,
  postdata = null
) {
  return await GpwisJobservices.gpwisSaveJobUnloadingDetailsService(
    SERVICE_URL + "/gpwis/jobunloadingdetails",
    params,
    postdata,
    CONFIG_HEADERS
  );
}

export async function activeJobsList() {
  return await MasterServices.activeJobsListService(
    SERVICE_URL + "/master/activejob",
    CONFIG_HEADERS
  );
}

export async function sftoJobOriginDetailsSave(postdata = null) {
  return await SftoJobservices.sftoJobOriginDetailsSaveService(
    SERVICE_URL + "/sfto/origindetails",
    postdata,
    CONFIG_HEADERS
  );
}

export async function dmsFileUpload(queryparams = null, postdata = null) {
  return await dmsFileUploadServices.dmsFileUploadService(
    SERVICE_URL + "/dms",
    queryparams,
    postdata,
    CONFIG_HEADERS
  );
}

export async function dmsFileDelete(queryparams = null) {
  return await dmsFileUploadServices.dmsFileDeleteService(
    SERVICE_URL + "/dms",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getSftoIntermediateStations(queryparams = null) {
  return await SftoJobservices.getSftoIntermediateStationsService(
    SERVICE_URL + "/sfto/intermediatestations",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getSftoRouteslist(queryparams = null) {
  return await SftoJobservices.getSftoRouteslistService(
    SERVICE_URL + "/sfto/routes",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveRoute(postdata = null) {
  return await SftoJobservices.saveRouteService(
    SERVICE_URL + "/sfto/routes",
    postdata,
    CONFIG_HEADERS
  );
}

export async function saveMastersRoute(postdata = null) {
  return await SftoJobservices.saveRouteService(
    SERVICE_URL + "/masters/addroute",
    postdata,
    CONFIG_HEADERS
  );
}

export async function saveSftoLoadingPoints(postdata = null) {
  return await SftoJobservices.saveSftoLoadingPointsService(
    SERVICE_URL + "/sfto/loadingpoints",
    postdata,
    CONFIG_HEADERS
  );
}

export async function getSftoLoadingPoints(queryparams = null) {
  return await SftoJobservices.getSftoLoadingPointsService(
    SERVICE_URL + "/sfto/loadingpoints",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function sftoWagonExcelParse(postdata = null) {
  return await SftoJobservices.sftoWagonExcelParseService(
    SERVICE_URL + "/sfto/parsewagonlistexcel",
    postdata,
    CONFIG_HEADERS
  );
}
export async function sftoCalculateFee(postdata = null) {
  return await SftoJobservices.sftoCalculateFeeService(
    SERVICE_URL + "/sfto/calculatefee",
    postdata,
    CONFIG_HEADERS
  );
}
export async function rakeWagonList(queryparams = null) {
  return await MasterServices.rakeWagonListService(
    SERVICE_URL + "/master/rakewagons",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveSftoWagondetails(postdata = null) {
  return await SftoJobservices.saveSftoWagondetailsService(
    SERVICE_URL + "/sfto/wagondetails",
    postdata,
    CONFIG_HEADERS
  );
}

export async function getSftoWagondetails(queryparams = null) {
  return await SftoJobservices.getSftoWagondetailsService(
    SERVICE_URL + "/sfto/wagondetails",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function saveSftoRRdetails(postdata = null) {
  return await SftoJobservices.saveSftoRRService(
    SERVICE_URL + "/sfto/rrdetails",
    postdata,
    CONFIG_HEADERS
  );
}
export async function getSftoRRdetails(queryparams = null) {
  return await SftoJobservices.getSftoRRService(
    SERVICE_URL + "/sfto/rrdetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveSftoRROtherdetails(postdata = null) {
  return await SftoJobservices.saveSftoRROtherdetailsService(
    SERVICE_URL + "/sfto/rrothercharges",
    postdata,
    CONFIG_HEADERS
  );
}
export async function getSftoRROtherdetails(queryparams = null) {
  return await SftoJobservices.getSftoRROtherdetailsService(
    SERVICE_URL + "/sfto/rrothercharges",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveSftoRouteFinalisationdetails(postdata = null) {
  return await SftoJobservices.saveSftoRouteFinalisationdetailsService(
    SERVICE_URL + "/sfto/routefinalisation",
    postdata,
    CONFIG_HEADERS
  );
}
export async function getSftoRouteFinalisationdetails(queryparams = null) {
  return await SftoJobservices.getSftoRouteFinalisationdetailsService(
    SERVICE_URL + "/sfto/routefinalisation",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveSftoIntransitdetails(postdata = null) {
  return await SftoJobservices.saveSftoIntransitdetailsService(
    SERVICE_URL + "/sfto/intransitdetails",
    postdata,
    CONFIG_HEADERS
  );
}
export async function getSftoIntransitdetails(queryparams = null) {
  return await SftoJobservices.getSftoIntransitdetailsService(
    SERVICE_URL + "/sfto/intransitdetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveSftoDestinationdetails(postdata = null) {
  return await SftoJobservices.saveSftoDestinationdetailsService(
    SERVICE_URL + "/sfto/destinationdetails",
    postdata,
    CONFIG_HEADERS
  );
}

export async function saveSftoContractdetails(postdata = null) {
  return await SftoJobservices.saveSftoContractdetailsService(
    SERVICE_URL + "/sfto/jobheader",
    postdata,
    CONFIG_HEADERS
  );
}

export async function getSftoDestinationdetails(queryparams = null) {
  return await SftoJobservices.getSftoDestinationdetailsService(
    SERVICE_URL + "/sfto/destinationdetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveSftoReturndetails(postdata = null) {
  return await SftoJobservices.saveSftoReturndetailsService(
    SERVICE_URL + "/sfto/returndetails",
    postdata,
    CONFIG_HEADERS
  );
}
export async function getSftoReturndetails(queryparams = null) {
  return await SftoJobservices.getSftoReturndetailsService(
    SERVICE_URL + "/sfto/returndetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function activeJobdetails(queryparams = null) {
  return await Dsrservices.activeJobdetailsService(
    SERVICE_URL + "/master/dailystatusreport",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function searchDamageWagonlist(queryparams = null) {
  return await DamageWagonService.searchDamageWagonlistService(
    SERVICE_URL + "/master/damagewagonslist",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getDashboardInvoiceDetails(
  queryparams = null,
  psd_token
) {
  CONFIG_HEADERS.token = psd_token
    ? psd_token
    : sessionStorage.getItem("token");

  return await DamageWagonService.searchDashboardlistService(
    SERVICE_URL + "/dashboard/invoicedetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getDashboardSFTOJobDetails(
  queryparams = null,
  psd_token
) {
  CONFIG_HEADERS.token = psd_token
    ? psd_token
    : sessionStorage.getItem("token");

  return await DamageWagonService.searchDashboardlistService(
    SERVICE_URL + "/dashboard/sftoJobDetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getDashboardGPWISJobDetails(
  queryparams = null,
  psd_token
) {
  CONFIG_HEADERS.token = psd_token
    ? psd_token
    : sessionStorage.getItem("token");

  return await DamageWagonService.searchDashboardlistService(
    SERVICE_URL + "/dashboard/gpwisJobDetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getDashboardSFTOReports(queryparams = null, psd_token) {
  CONFIG_HEADERS.token = psd_token
    ? psd_token
    : sessionStorage.getItem("token");

  return await DamageWagonService.searchDashboardlistService(
    SERVICE_URL + "/dashboard/sftoreports",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getDashboardGPWISReports(queryparams = null, psd_token) {
  CONFIG_HEADERS.token = psd_token
    ? psd_token
    : sessionStorage.getItem("token");

  return await DamageWagonService.searchDashboardlistService(
    SERVICE_URL + "/dashboard/gpwisreports",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function searchRakeInductionList(queryparams = null) {
  return await RakeInductionServices.searchRakeInductionListService(
    SERVICE_URL + "/master/damagewagonslist",
    queryparams,
    CONFIG_HEADERS
  );
}

// export async function saveWagonMaster(postdata = null) {
//   return await MasterServices.saveWagonMasterService (
//     SERVICE_URL + "/wagonmaster/createwagonmaster",
//     postdata,
//     CONFIG_HEADERS
//   );
// }

export async function saveDamageWagon(postdata = null) {
  return await DamageWagonService.saveDamageWagonService(
    SERVICE_URL + "/master/damagewagons",
    postdata,
    CONFIG_HEADERS
  );
}

export async function saveSftoCommercialDetails(postdata = null) {
  return await SftoJobservices.saveSftoCommercialDetailsService(
    SERVICE_URL + "/sfto/commercialdetails",
    postdata,
    CONFIG_HEADERS
  );
}

export async function generateSftoPackinglist(postdata = null) {
  return await SftoJobservices.generateSftoPackinglistService(
    SERVICE_URL + "/sfto/generatepackinglist",
    CONFIG_HEADERS,
    postdata
  );
}

export async function getLiveRakesList() {
  //
  return await TrackRakeServices.getLiveRakesListService(
    SERVICE_URL + "/trackrake/listliverakes",
    CONFIG_HEADERS
  );
}

export async function getRakesList() {
  //
  return await TrackRakeServices.getLiveRakesListService(
    SERVICE_URL + "/intransitdsrrecords",
    CONFIG_HEADERS
  );
}

export async function getRakesListByCustomerName(queryparams = null) {
  return await RakeInductionServices.searchRakeInductionListService(
    SERVICE_URL + "/trackrake/intransitdsrrecordsbycustomername",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getCreditlimitCheckDetails(postdata = null) {
  return await SapTransactionServices.getCreditlimitCheckDetailsService(
    SERVICE_URL + "/sfto/saptransaction",
    postdata,
    CONFIG_HEADERS
  );
}

export async function createProformaInvoice(postdata = null) {
  return await SapTransactionServices.createProformaInvoiceService(
    SERVICE_URL + "/sfto/saptransaction",
    postdata,
    CONFIG_HEADERS
  );
}

export async function createSFTOIO(postdata = null, sapCredintials = null) {
  // CONFIG_HEADERS.sap_user_name = sapCredintials.username;
  // CONFIG_HEADERS.sap_password = sapCredintials.password;
  CONFIG_HEADERS.sap_name_pw = await getEncodedUserPw(sapCredintials);
  return await SapTransactionServices.createSFTOIOService(
    SERVICE_URL + "/sfto/saptransaction",
    postdata,
    CONFIG_HEADERS
  );
}

export async function createGPWISIO(postdata = null, sapCredintials = null) {
  // CONFIG_HEADERS.sap_user_name = sapCredintials.username;
  // CONFIG_HEADERS.sap_password = sapCredintials.password;
  CONFIG_HEADERS.sap_name_pw = await getEncodedUserPw(sapCredintials);
  return await SapTransactionServices.createGPWISIOService(
    SERVICE_URL + "/gpwis/saptransaction",
    postdata,
    CONFIG_HEADERS
  );
}

export async function createGPWISSO(postdata = null, sapCredintials = null) {
  // CONFIG_HEADERS.sap_user_name = sapCredintials.username;
  // CONFIG_HEADERS.sap_password = sapCredintials.password;
  CONFIG_HEADERS.sap_name_pw = await getEncodedUserPw(sapCredintials);
  return await SapTransactionServices.createGPWISSOService(
    SERVICE_URL + "/gpwis/saptransaction",
    postdata,
    CONFIG_HEADERS
  );
}

export async function generateSftoDestinationmemo(postdata = null) {
  return await SftoJobservices.generateSftoDestinationmemoService(
    SERVICE_URL + "/sfto/generatedestinationmemo",
    CONFIG_HEADERS,
    postdata
  );
}

export async function getoriginslist(queryparams = null) {
  return await SftoJobservices.getOriginsListService(
    SERVICE_URL + "/origindetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getdestinationslist(queryparams = null) {
  return await SftoJobservices.getDestinationsListService(
    SERVICE_URL + "/destinationdetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveWagonMaster(postdata = null) {
  return await MasterServices.saveWagonMasterService(
    SERVICE_URL + "/wagonmaster/createwagonmaster",
    postdata,
    CONFIG_HEADERS
  );
}

export async function searchRouteMaster(queryparams = null) {
  return await MasterServices.searchMasterslistService(
    SERVICE_URL + "/master/routemasterheaderList",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function searchRakeMaster(queryparams = null) {
  return await MasterServices.searchMasterslistService(
    SERVICE_URL + "/master/rakemasterlist",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getRouteMasterDivisionDetails(queryparams = null) {
  return await MasterServices.searchMasterslistService(
    SERVICE_URL + "/master/createroutemasterdetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveRakeMaster(postdata = null) {
  return await MasterServices.saveRakeMasterService(
    SERVICE_URL + "/master/createrakemaster",
    postdata,
    CONFIG_HEADERS
  );
}

export async function saveRouteMasterHeader(postdata = null) {
  return await MasterServices.saveRakeMasterService(
    SERVICE_URL + "/master/createroutemasterheader",
    postdata,
    CONFIG_HEADERS
  );
}

export async function saveRouteMasterDetails(postdata = null) {
  return await MasterServices.saveRakeMasterService(
    SERVICE_URL + "/master/createroutemasterdetails",
    postdata,
    CONFIG_HEADERS
  );
}

export async function searchWagonMasterlist(queryparams) {
  return await MasterServices.wagonMasterlistService(
    SERVICE_URL + "/masters/wagon",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getRouteMasterDetails(queryparams = null) {
  return await MasterServices.wagonMasterlistService(
    SERVICE_URL + "/master/createroutemasterdetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getMastersRoutes(queryparams = null) {
  return await MasterServices.wagonMasterlistService(
    SERVICE_URL + "/masters/addroute",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function searchRakeMaintenance(queryparams = null) {
  return await RakeMaintenanceService.searchRakeMasterListService(
    SERVICE_URL + "/rakemaintenance",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveRakeMaintenance(postdata = null) {
  return await RakeMaintenanceService.saveRakeMaintenanceService(
    SERVICE_URL + "/rake/rakemaintenance",
    postdata,
    CONFIG_HEADERS
  );
}
export async function getRakeMaintenanceDetails(queryparams = null) {
  return await RakeMaintenanceService.getRakeInductionDetailsService(
    SERVICE_URL + "/rake/rakemaintenance",
    queryparams,
    CONFIG_HEADERS
  );
}

//  Rake Induction Services

export async function saveQuotaionFromSupplier(postdata = null) {
  return await RakeInductionServices.saveQuotaionFromSupplierService(
    SERVICE_URL + "/rakeinduction/quotationfromsupplier",
    postdata,
    CONFIG_HEADERS
  );
}

export async function searchQuotationFromSupplier(queryparams = null) {
  return await RakeInductionServices.searchQuotaionFromSupplierService(
    SERVICE_URL + "/rakeinduction/quotationfromsupplier",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getQuotationFromSupplier() {
  return await RakeInductionServices.getQuotationFromSupplierListService(
    SERVICE_URL + "/rakeinduction/quotationfromsupplier",
    CONFIG_HEADERS
  );
}

export async function savePOToSupplier(postdata = null) {
  return await RakeInductionServices.savePOToSupplierService(
    SERVICE_URL + "/rakeinduction/potosupplier",
    postdata,
    CONFIG_HEADERS
  );
}

export async function searchPOToSupplier(queryparams = null) {
  return await RakeInductionServices.searchPOToSupplierService(
    SERVICE_URL + "/rakeinduction/potosupplier",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveInspectionAgency(postdata = null) {
  return await RakeInductionServices.saveInspectionAgencyService(
    SERVICE_URL + "/rakeinduction/inspectionagency",
    postdata,
    CONFIG_HEADERS
  );
}

export async function searchInspectionAgency(queryparams = null) {
  return await RakeInductionServices.searchInspectionAgencyService(
    SERVICE_URL + "/rakeinduction/inspectionagency",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveDeliveryConfirmation(postdata = null) {
  return await RakeInductionServices.saveDeliveryConfirmationService(
    SERVICE_URL + "/rakeinduction/deliveryconfirmation",
    postdata,
    CONFIG_HEADERS
  );
}

export async function getDeliveryConfirmation(queryparams = null) {
  return await RakeInductionServices.searchDeliveryConfirmationService(
    SERVICE_URL + "/rakeinduction/deliveryconfirmation",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveRakeManufacturing(postdata = null) {
  return await RakeInductionServices.saveRakeManufacturingService(
    SERVICE_URL + "/rakeinduction/rakemanufacturing",
    postdata,
    CONFIG_HEADERS
  );
}

export async function searchRakeManufacturing(queryparams = null) {
  return await RakeInductionServices.searchRakeManufacturingService(
    SERVICE_URL + "/rakeinduction/rakemanufacturing",
    queryparams,
    CONFIG_HEADERS
  );
}

// Rake Commissioning
export async function saveRakeCommissioning(postdata = null) {
  return await RakeInductionServices.saveRakeCommissioningService(
    SERVICE_URL + "/rakeinduction/commissioning",
    postdata,
    CONFIG_HEADERS
  );
}

export async function searchRakeCommissioning(queryparams = null) {
  return await RakeInductionServices.searchRakeCommissioningService(
    SERVICE_URL + "/rakeinduction/commissioning",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveSapDefaults(postdata = null) {
  return await SapTransactionServices.saveSapDefaultsService(
    SERVICE_URL + "/sap/defaultvalues",
    postdata,
    CONFIG_HEADERS
  );
}

export async function getSapDefaults(queryparams = null) {
  return await SapTransactionServices.getSapDefaultsService(
    SERVICE_URL + "/sap/defaultvalues",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveContractAdvanceDetails(postdata = null) {
  return await SapTransactionServices.saveContractAdvanceDetailsService(
    SERVICE_URL + "/sap/contractadvancedetails",
    postdata,
    CONFIG_HEADERS
  );
}

export async function getContractAdvanceDetails(queryparams = null) {
  return await SapTransactionServices.getContractAdvanceDetailsService(
    SERVICE_URL + "/sap/contractadvancedetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getContractDetails(queryparams = null) {
  return await MasterServices.getContractDetailsService(
    SERVICE_URL + "/contractdetails",
    queryparams,
    CONFIG_HEADERS
  );
}

// export async function getContractStationsDetails(queryparams = null) {
//   return await MasterServices.getContractStationsDetailsService(
//     SERVICE_URL + "/contractstations",
//     queryparams,
//     CONFIG_HEADERS
//   );
// }

// export async function createSFTOSO(postdata = null) {
//   return await SapTransactionServices.createSFTOSOService(
//     SERVICE_URL + "/sfto/saptransaction",
//     postdata,
//     CONFIG_HEADERS
//   );
// }

// Spare Wagon Delivery
export async function saveSpareWagonDelivery(postdata = null) {
  return await RakeInductionServices.saveSpareWagonDeliveryService(
    SERVICE_URL + "/rake/sparewagoninduction",
    postdata,
    CONFIG_HEADERS
  );
}
export async function saveSpareWagonCommissioning(postdata = null) {
  return await RakeInductionServices.saveSpareWagonCommissioningService(
    SERVICE_URL + "/rake/sparewagoninductioncommissioning",
    postdata,
    CONFIG_HEADERS
  );
}

export async function getLiveRakeGpsDetails(queryparams = null) {
  //
  return await TrackRakeServices.getLiveRakeGpsDetailsService(
    SERVICE_URL + "/liverakegpspoints",
    CONFIG_HEADERS
  );
}
export async function getContractStationsDetails(queryparams = null) {
  return await MasterServices.getContractStationsDetailsService(
    SERVICE_URL + "/contractstations",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function createSFTOSO(postdata = null, sapCredintials = null) {
  // CONFIG_HEADERS.sap_user_name = sapCredintials.username;
  // CONFIG_HEADERS.sap_password = sapCredintials.password;
  CONFIG_HEADERS.sap_name_pw = await getEncodedUserPw(sapCredintials);
  return await SapTransactionServices.createSFTOSOService(
    SERVICE_URL + "/sfto/saptransaction",
    postdata,
    CONFIG_HEADERS
  );
}

export async function createSFTOPO(postdata = null, sapCredintials = null) {
  // CONFIG_HEADERS.sap_user_name = sapCredintials.username;
  // CONFIG_HEADERS.sap_password = sapCredintials.password;
  CONFIG_HEADERS.sap_name_pw = await getEncodedUserPw(sapCredintials);
  return await SapTransactionServices.createSFTOSOService(
    SERVICE_URL + "/sfto/sappotransaction",
    postdata,
    CONFIG_HEADERS
  );
}

export async function getSpareWagonCommissioning(queryparams = null) {
  return await RakeInductionServices.getSpareWagonCommissioningService(
    SERVICE_URL + "/rake/sparewagoninductioncommissioning",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getSpareWagonDelivery(queryparams = null) {
  return await RakeInductionServices.getSpareWagonDeliveryService(
    SERVICE_URL + "/rake/sparewagoninduction",
    queryparams,
    CONFIG_HEADERS
  );
}
// export async function getLiveRakeGpsDetails(queryparams = null) {
//   return await TrackRakeServices.getLiveRakeGpsDetailsService(
//     SERVICE_URL + "/liverakegpspoints",
//     queryparams,
//     CONFIG_HEADERS
//   );
// }

export async function updateSFTOSO(postdata = null, sapCredintials = null) {
  // CONFIG_HEADERS.sap_user_name = sapCredintials.username;
  // CONFIG_HEADERS.sap_password = sapCredintials.password;
  CONFIG_HEADERS.sap_name_pw = await getEncodedUserPw(sapCredintials);
  return await SapTransactionServices.updateSFTOSOService(
    SERVICE_URL + "/sfto/saptransaction",
    postdata,
    CONFIG_HEADERS
  );
}

export async function createInvoice(postdata = null, sapCredintials = null) {
  // CONFIG_HEADERS.sap_user_name = sapCredintials.username;
  // CONFIG_HEADERS.sap_password = sapCredintials.password;
  CONFIG_HEADERS.sap_name_pw = await getEncodedUserPw(sapCredintials);
  return await SapTransactionServices.createInvoiceService(
    SERVICE_URL + "/sfto/saptransaction",
    postdata,
    CONFIG_HEADERS
  );
}

export async function generateLoadNo(queryparams = null) {
  return await MasterServices.generateLoadNoService(
    SERVICE_URL + "/generateloadno",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function savedashboardinvoicedetails(postdata = null) {
  return await RakeInductionServices.saveSpareWagonCommissioningService(
    SERVICE_URL + "/dashboard/saveinvoicedetails",
    postdata,
    CONFIG_HEADERS
  );
}

export async function getGPWISInvoiceDetailsBasedOnJob(queryparams = null) {
  return await MasterServices.generateLoadNoService(
    SERVICE_URL + "/gpwis/getJobInvoiceDetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getSFTOInvoiceDetailsBasedOnJob(queryparams = null) {
  return await MasterServices.generateLoadNoService(
    SERVICE_URL + "/sfto/getJobInvoiceDetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveJobDetailsForThresholdLogic(postdata = null) {
  return await RakeInductionServices.saveSpareWagonCommissioningService(
    SERVICE_URL + "/sfto/saveThresholdLogic",
    postdata,
    CONFIG_HEADERS
  );
}

export async function saveThresholdLogicQuantity(postdata = null) {
  return await RakeInductionServices.saveSpareWagonCommissioningService(
    SERVICE_URL + "/sfto/saveThresholdLogicQuantity",
    postdata,
    CONFIG_HEADERS
  );
}

export async function updateGPWISSO(postdata = null, sapCredintials = null) {
  // CONFIG_HEADERS.sap_user_name = sapCredintials.username;
  // CONFIG_HEADERS.sap_password = sapCredintials.password;
  CONFIG_HEADERS.sap_name_pw = await getEncodedUserPw(sapCredintials);
  return await SapTransactionServices.updateGPWISSOService(
    SERVICE_URL + "/gpwis/saptransaction",
    postdata,
    CONFIG_HEADERS
  );
}

export async function createGPWISInvoice(
  postdata = null,
  sapCredintials = null
) {
  // CONFIG_HEADERS.sap_user_name = sapCredintials.username;
  // CONFIG_HEADERS.sap_password = sapCredintials.password;
  CONFIG_HEADERS.sap_name_pw = await getEncodedUserPw(sapCredintials);
  return await SapTransactionServices.createInvoiceGPWISService(
    SERVICE_URL + "/gpwis/saptransaction",
    postdata,
    CONFIG_HEADERS
  );
}

export async function getGPSCoordinates(queryparams = null) {
  return await SftoJobservices.getOriginsListService(
    SERVICE_URL + "/trackrake/rakegpscoordinates",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getCustomerRefNumber(queryparams = null) {
  return await SftoJobservices.getOriginsListService(
    SERVICE_URL + "/sfto/thresholdLogic",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getThresholdRemainingAmountbyCustomerRefNumber(
  queryparams = null
) {
  return await SftoJobservices.getOriginsListService(
    SERVICE_URL + "/sfto/thresholdRemainingAmount",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function downloadDashboardJobDetails(start_date, end_date) {
  let filename =
    "SFTO_Jobs_List_" + moment(Date.now()).format("DD-MM-YYYY") + ".xlsx";
  return await SftoJobservices.downloadDashboardJobDetailsService(
    SERVICE_URL +
      "/dashboard/downloadSftoJobDetails?rr_start_date=" +
      start_date +
      "&rr_end_date=" +
      end_date,
    filename,
    CONFIG_HEADERS
  );
}

export async function downloadDashboardReports(postdata = null) {
  let filename =
    "Tonnage_Report_" + moment(Date.now()).format("DD-MM-YYYY") + ".xlsx";
  return await SftoJobservices.downloadReports(
    SERVICE_URL + "/tonnage/report",
    filename,
    CONFIG_HEADERS,
    postdata
  );
}

export async function downloadIdelWeightReports(postdata = null) {
  let filename =
    "IDLE_Weight_Report_" + moment(Date.now()).format("DD-MM-YYYY") + ".xlsx";
  return await SftoJobservices.downloadReports(
    SERVICE_URL + "/idelweight/report",
    filename,
    CONFIG_HEADERS,
    postdata
  );
}

export async function downloadDetentionDashboardReports(postdata = null) {
  let filename =
    "Rake_Detention_Report_" +
    moment(Date.now()).format("DD-MM-YYYY") +
    ".xlsx";
  return await SftoJobservices.downloadReports(
    SERVICE_URL + "/rakedetention/report",
    filename,
    CONFIG_HEADERS,
    postdata
  );
}

export async function downloadDashboardGpwisJobDetails(start_date, end_date) {
  let filename =
    "GPWIS_Jobs_List_" + moment(Date.now()).format("DD-MM-YYYY") + ".xlsx";
  return await SftoJobservices.downloadDashboardJobDetailsService(
    SERVICE_URL +
      "/dashboard/downloadGpwisJobDetails?rr_start_date=" +
      start_date +
      "&rr_end_date=" +
      end_date,
    filename,
    CONFIG_HEADERS
  );
}

export async function contractMasterExcelDownload(queryparams) {
  let filename =
    "CONTRACT_MASTER" + moment(Date.now()).format("DD-MM-YYYY") + ".xlsx";
  return await SftoJobservices.downloadDashboardJobDetailsService(
    SERVICE_URL + "/masters/downloadContractMasterData",
    filename,
    CONFIG_HEADERS,
    queryparams
  );
}

export async function contractHeaderlist(queryparams) {
  return await MasterServices.searchMasterslistService(
    SERVICE_URL + "/listview/contractHeaderAndLineItems",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getcontractHeaderlist(queryparams) {
  return await MasterServices.searchMasterslistService(
    SERVICE_URL + "/masters/contractHeaderAndLineItems",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function savecontractHeader(postdata = null) {
  return await MasterServices.saveWagonMasterService(
    SERVICE_URL + "/masters/contractHeaderAndLineItems",
    postdata,
    CONFIG_HEADERS
  );
}
export async function vendorMasterHeaderlist(queryparams) {
  return await MasterServices.searchVendorMasterlistService(
    SERVICE_URL + "/masters/VendorcontractMaster",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function savevendorMasterHeader(postdata = null) {
  return await MasterServices.saveVendorMasterService(
    SERVICE_URL + "/masters/VendorcontractMaster",
    postdata,
    CONFIG_HEADERS
  );
}

export async function saveShipToPartyMaster(postdata = null) {
  return await MasterServices.saveWagonMasterService(
    SERVICE_URL + "/masters/shipToPartyMaster",
    postdata,
    CONFIG_HEADERS
  );
}

export async function deletecontractLineItem(queryparams) {
  return await MasterServices.deleteContractLineItemService(
    SERVICE_URL + "/masters/contractHeaderAndLineItems",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getContractNoList(queryparams) {
  return await MasterServices.getContractDetailsService(
    SERVICE_URL + "/master/activeContracts",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getCustomerList(queryparams) {
  return await MasterServices.searchMastersFilterService(
    SERVICE_URL + "/master/activeContractsCustomerNames",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getVendorList(queryparams) {
  return await MasterServices.searchVendorMastersFilterService(
    SERVICE_URL + "/masters/getvendornames ",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getDashboardData(queryparams, psd_token) {
  CONFIG_HEADERS.token = psd_token
    ? psd_token
    : sessionStorage.getItem("token");

  return await MasterServices.getDashboardDataService(
    SERVICE_URL + "/dashboard/dashboardDetails",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getDashboardStatusDetails(queryparams, psd_token) {
  CONFIG_HEADERS.token = psd_token
    ? psd_token
    : sessionStorage.getItem("token");

  return await MasterServices.getDashboardStatusDetailsService(
    SERVICE_URL + "/dashboard/dashboardStatusDetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function uploadExcellForContractMaster(postdata = null) {
  return await MasterServices.saveWagonMasterService(
    SERVICE_URL + "/masters/exceluploadforcontractheaderandlineitems",
    postdata,
    CONFIG_HEADERS
  );
}

export async function uploadExcellForWagonMaster(postdata = null) {
  return await MasterServices.saveWagonMasterService(
    SERVICE_URL + "/masters/exceluploadforwagon",
    postdata,
    CONFIG_HEADERS
  );
}

export async function commodityList(queryparams) {
  return await MasterServices.getCommodityMasterList(
    SERVICE_URL + "/master/commodityList",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function shipToPartyMastersList(queryparams) {
  return await MasterServices.getCommodityMasterList(
    SERVICE_URL + "/masters/shipToPartyMaster",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveCommodityMaster(postdata = null) {
  return await MasterServices.saveRakeMasterService(
    SERVICE_URL + "/master/commodity",
    postdata,
    CONFIG_HEADERS
  );
}

export async function commodityMasterDetails(queryparams = null) {
  return await MasterServices.getCommodityDetails(
    SERVICE_URL + "/master/commodity",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function testSendingMail(queryparams = null) {
  return await MasterServices.getCommodityDetails(
    SERVICE_URL + "/master/sendMailTest",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getThresholdMasterlist(queryparams, psd_token) {
  CONFIG_HEADERS.token = psd_token
    ? psd_token
    : sessionStorage.getItem("token");

  return await MasterServices.wagonMasterlistService(
    SERVICE_URL + "/masters/listThresholdMaster",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveCustomerThreholdValue(postdata = null) {
  return await MasterServices.saveCustomerThreshold(
    SERVICE_URL + "/masters/customerThresholdMaster",
    postdata,
    CONFIG_HEADERS
  );
}

export async function getCustomerThresholdDetails(queryparams = null) {
  return await MasterServices.getCustomerThresholdDetails(
    SERVICE_URL + "/masters/customerThresholdMaster",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getCustomerRefDetails(queryparams = null) {
  return await MasterServices.getCustomerThresholdDetails(
    SERVICE_URL + "/masters/customerRefList",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function tripWiseProfitabilityReport(param = null) {
  return await ReportServices.getReport(
    SERVICE_URL + "/tripWiseProfitability/report",
    param,
    CONFIG_HEADERS
  );
}

export async function downloadTripWiseProfitabilityReports(postdata = null) {
  let filename =
    "TripWise_Profitability_Report_" +
    moment(Date.now()).format("DD-MM-YYYY") +
    ".xlsx";
  return await SftoJobservices.downloadReports(
    SERVICE_URL + "/tripWiseProfitability/report",
    filename,
    CONFIG_HEADERS,
    postdata
  );
}
export async function rebatesummaryreport(param = null) {
  return await ReportServices.rebatesummaryreport(
    SERVICE_URL + "/gpwis/rebatesummaryreport",
    param,
    CONFIG_HEADERS
  );
}
export async function getgpwrsdata(queryparams = null) {
  return await GpwisJobservices.getgpwrsdata(
    SERVICE_URL + "/gpwis/getdata",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function createSAPIO(postdata = null, sapCredintials = null) {
  // CONFIG_HEADERS.sap_user_name = sapCredintials.username;
  // CONFIG_HEADERS.sap_password = sapCredintials.password;
  CONFIG_HEADERS.sap_name_pw = await getEncodedUserPw(sapCredintials);
  return await SapTransactionServices.createSFTOIOService(
    SERVICE_URL + "/sap/createIO",
    postdata,
    CONFIG_HEADERS
  );
}
// export async function getRRDetailsfromDoc(queryparams = null, postdata = null) {
//   return await dmsFileUploadServices.dmsFileUploadService(
//     SERVICE_URL + "/rrDocUploadDetails",
//     queryparams,
//     postdata,
//     CONFIG_HEADERS
//   );
// }
export async function createSAPSO(postdata = null, sapCredintials = null) {
  // CONFIG_HEADERS.sap_user_name = sapCredintials.username;
  // CONFIG_HEADERS.sap_password = sapCredintials.password;
  CONFIG_HEADERS.sap_name_pw = await getEncodedUserPw(sapCredintials);
  return await SapTransactionServices.createSFTOIOService(
    SERVICE_URL + "/sap/createSO",
    postdata,
    CONFIG_HEADERS
  );
}

export async function createSAPInvoie(postdata = null, sapCredintials = null) {
  // CONFIG_HEADERS.sap_user_name = sapCredintials.username;
  // CONFIG_HEADERS.sap_password = sapCredintials.password;
  CONFIG_HEADERS.sap_name_pw = await getEncodedUserPw(sapCredintials);
  return await SapTransactionServices.createSFTOIOService(
    SERVICE_URL + "/sap/createInvoice",
    postdata,
    CONFIG_HEADERS
  );
}

export async function createGPWISSAPSO(postdata = null, sapCredintials = null) {
  // CONFIG_HEADERS.sap_user_name = sapCredintials.username;
  // CONFIG_HEADERS.sap_password = sapCredintials.password;
  CONFIG_HEADERS.sap_name_pw = await getEncodedUserPw(sapCredintials);
return await SapTransactionServices.createSFTOIOService(
    SERVICE_URL + "/sap/createGPWISSO",
    postdata,
    CONFIG_HEADERS
  );
}
export async function getMaterialClassMasterList(queryparams = null) {
  return await MasterServices.getMaterialClassMasterList(
    SERVICE_URL + "/master/materialclassdetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveMaterialClassMaster(queryparams = null) {
  return await MasterServices.saveMaterialClassMaster(
    SERVICE_URL + "/master/materialclassdetails",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getFrieghtsMasterList(queryparams = null) {
  return await MasterServices.getFrieghtsMasterList(
    SERVICE_URL + "/master/frieghtmasterdetails",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function saveFrieghtsMaster(queryparams = null) {
  return await MasterServices.saveFrieghtsMaster(
    SERVICE_URL + "/master/frieghtmasterdetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getRakeMasterList(queryparams = null) {
  return await MasterServices.getRakeMasterList(
    SERVICE_URL + "/master/rakerebatemasterdetails",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function saveRakeRebateMaster(queryparams = null) {
  return await MasterServices.saveRakeRebateMaster(
    SERVICE_URL + "/master/rakerebatemasterdetails",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function calculateRebate(queryparams = null) {
  return await GpwisJobservices.calculateRebateAmount(
    SERVICE_URL + "/gpwis/calculaterebate",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getgpwrsdistance(queryparams = null) {
  return await GpwisJobservices.getgpwrsdistance(
    SERVICE_URL + "/gpwis/getdata",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getInvoiceSftoDeatilsReport(param = null) {
  return await ReportServices.getInvoiceSftoDeatilsReport(
    SERVICE_URL + "/sfto/invoiceDetailsReport",
    param,
    CONFIG_HEADERS
  );
}

export async function getSftoJobDeatilsReport(param = null) {
  return await ReportServices.getSftoJobDeatilsReports(
    SERVICE_URL + "/sftoJobReport",
    param,
    CONFIG_HEADERS
  );
}
export async function downloadSftoInvoiceDetailsReports(postdata = null) {
  let filename =
    "SFTO_InvoiceDetails_Report_" +
    moment(Date.now()).format("DD-MM-YYYY") +
    ".xlsx";
  return await ReportServices.downloadSftoInvoiceDetailsReport(
    SERVICE_URL + "/sfto/downloadInvoiceDetails",
    filename,
    CONFIG_HEADERS,
    postdata
  );
}

export async function getInvoiceGpwisDeatilsReport(param = null) {
  return await ReportServices.getInvoiceSftoDeatilsReport(
    SERVICE_URL + "/gpwis/invoiceDetailsReport",
    param,
    CONFIG_HEADERS
  );
}
export async function downloadSftoJobDetailsReports(postdata = null) {
  let filename =
    "SFTO_JobDetails_Report_" +
    moment(Date.now()).format("DD-MM-YYYY") +
    ".xlsx";
  return await SftoJobservices.downloadSftoJobDetailsReport(
    SERVICE_URL + "/sftoJobReport/exportExcel",
    filename,
    CONFIG_HEADERS,
    postdata
  );
}

export async function getGpwisJobDeatilsReport(param = null) {
  return await ReportServices.getSftoJobDeatilsReports(
    SERVICE_URL + "/gpwisJobReport",
    param,
    CONFIG_HEADERS
  );
}
export async function downloadGpwisJobDetailsReports(postdata = null) {
  let filename =
    "GPWIS_JobDetails_Report_" +
    moment(Date.now()).format("DD-MM-YYYY") +
    ".xlsx";
  return await SftoJobservices.downloadSftoJobDetailsReport(
    SERVICE_URL + "/gpwisJobReport/exportExcel",
    filename,
    CONFIG_HEADERS,
    postdata
  );
}

export async function getRRDetailsfromDoc(queryparams = null, postdata = null) {
  return await dmsFileUploadServices.dmsFileUploadService(
    SERVICE_URL + "/rrDocUploadDetails",
    queryparams,
    postdata,
    CONFIG_HEADERS
  );
}

export async function getBPCDetailsfromDoc(
  queryparams = null,
  postdata = null
) {
  return await dmsFileUploadServices.bpcFileUploadService(
    SERVICE_URL + "/bpcDocUploadDetails",
    queryparams,
    postdata,
    CONFIG_HEADERS
  );
}

export async function downloadGpwisInvoiceDetailsReports(postdata = null) {
  let filename =
    "GPWIS_InvoiceDetails_Report_" +
    moment(Date.now()).format("DD-MM-YYYY") +
    ".xlsx";
  return await ReportServices.downloadGpwisInvoiceDetailsReport(
    SERVICE_URL + "/gpwis/downloadInvoiceDetails",
    filename,
    CONFIG_HEADERS,
    postdata
  );
}

export async function getODMasterList(queryparams = null) {
  return await MasterServices.getODMasterList(
    SERVICE_URL + "/master/odmasterdetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveODMaster(queryparams = null) {
  return await MasterServices.saveODMaster(
    SERVICE_URL + "/master/odmasterdetails",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function userLogout(postedData) {
  return await AccountServices.userLogoutDetails(
    SERVICE_URL + "/logout ",
    postedData,
    CONFIG_HEADERS
  );
}

export async function getTATReconciliationMasterTransactorList(
  queryparams = null
) {
  return await MasterServices.getTATReconciliationMasterTransactorList(
    SERVICE_URL + "/master/tatreconciliationmaster",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function saveTATReconciliationMaster(queryparams = null) {
  return await MasterServices.saveTATReconciliationMaster(
    SERVICE_URL + "/master/tatreconciliationmaster",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getInvoiceReportDetails(queryparams = null) {
  return await ReportServices.getInvoiceReportDetails(
    SERVICE_URL + "/report/invoicereportdetails",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getTATReportList(queryparams = null) {
  return await ReportServices.getTATReportList(
    SERVICE_URL + "/report/tatreport",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getTATReport(queryparams = null) {
  return await ReportServices.getTATReport(
    SERVICE_URL + "/report/tatreport",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getRevenueReportList(queryparams = null) {
  return await ReportServices.getRevenueReportList(
    SERVICE_URL + "/report/revenuereport",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getRevenueReport(queryparams = null) {
  return await ReportServices.getRevenueReport(
    SERVICE_URL + "/report/revenuereport",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getRakeRebateReportData(queryparams = null) {
  return await ReportServices.getRakeRebateReportData(
    SERVICE_URL + "/report/rakerebateinvoice",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function resetLogin(postedData, queryParams = null) {
  return await AccountServices.resetLogin(
    SERVICE_URL + "/resettoken",
    postedData,
    CONFIG_HEADERS
  );
}

export async function createRekRebateSO(queryparams = null) {
  return await SapTransactionServices.createRaekRebateInvoice(
    SERVICE_URL + "/report/rakerebatesogen",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function createRekRebateInvoice(
  queryparams = null,
  sapCredintials = null
) {
  CONFIG_HEADERS.sap_name_pw = await getEncodedUserPw(sapCredintials);
  return await SapTransactionServices.createRaekRebateInvoice(
    SERVICE_URL + "/report/rakerebateinvoice",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getClientDetails() {
  return await MasterServices.getUserClientData(SERVICE_URL + "/settings");
}

export async function getStationMasterList(queryparams = null) {
  return await MasterServices.getStationMaster(
    SERVICE_URL + "/master/station_master",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function createStationMasterList(postdata = null) {
  return await MasterServices.createStationMaster(
    SERVICE_URL + "/master/station_master",
    postdata,
    CONFIG_HEADERS
  );
}

export async function stationMasterExcelDownload(queryparams) {
  let filename =
    "STATION_MASTER" + moment(Date.now()).format("DD-MM-YYYY") + ".xlsx";
  return await MasterServices.downloadStationMaster(
    SERVICE_URL + "/master/station_master/download",
    filename,
    CONFIG_HEADERS,
    queryparams
  );
}

export async function cancelInvoiceDetails(
  postdata = null,
  sapCredintials = null
) {
  // CONFIG_HEADERS.sap_user_name = sapCredintials?.username;
  // CONFIG_HEADERS.sap_password = sapCredintials?.password;
  CONFIG_HEADERS.sap_name_pw = await getEncodedUserPw(sapCredintials);
  return await GpwisJobservices.createJobService(
    SERVICE_URL + "/sap/cancelSOandInvoice",
    postdata,
    CONFIG_HEADERS
  );
}

// Invoice Submission API
export async function getInvoiceList(param = null) {
  return await ReportServices.getInvoiceList(
    SERVICE_URL + "/invoicesubmission",
    param,
    CONFIG_HEADERS
  );
}

// Mantainancce Module
export async function saveExaminationTypeMaster(queryparams = null) {
  return await MasterServices.saveExaminationTypeMaster(
    SERVICE_URL + "/master/examinationtypemasterdetails",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getExaminationTypeMasterList(queryparams = null) {
  return await MasterServices.getExaminationTypeMasterList(
    SERVICE_URL + "/master/examinationtypemasterdetails",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function saveDepoMaster(queryparams = null) {
  return await MasterServices.saveDepoMaster(
    SERVICE_URL + "/master/depomasterdetails",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getDepoMasterList(queryparams = null) {
  return await MasterServices.getDepoMasterList(
    SERVICE_URL + "/master/depomasterdetails",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function saveWagonComponentMaster(queryparams = null) {
  return await MasterServices.saveWagonComponentMaster(
    SERVICE_URL + "/master/wagoncomponentmasterdetails",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getWagonComponentMasterList(queryparams = null) {
  return await MasterServices.getWagonComponentMasterList(
    SERVICE_URL + "/master/wagoncomponentmasterdetails",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getRohPohScheduleMasterList(queryparams = null) {
  return await MasterServices.getRohPohScheduleMasterList(
    SERVICE_URL + "/master/rohpohschedulemasterdetails",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function saveRohPohScheduleMaster(queryparams = null) {
  return await MasterServices.saveRohPohScheduleMaster(
    SERVICE_URL + "/master/rohpohschedulemasterdetails",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getUniqueWagonTypeList(queryparams = null) {
  return await MasterServices.getUniqueWagonTypeList(
    SERVICE_URL + "/master/uniquewagontype",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function wagonComponentMasterExcelDownload(queryparams) {
  let filename =
    "WAGON_COMPONENT_MASTER" + moment(Date.now()).format("DD-MM-YYYY") + ".xlsx";
  return await MasterServices.wagonComponentMasterExcelDownload(
    SERVICE_URL + "/master/wagoncomponentmasterdetails/download",
    filename,
    CONFIG_HEADERS,
    queryparams
  )
}
export async function wagonMasterListByRakeName(queryparams) {
  return await MasterServices.wagonMasterByRakeNameService(
    SERVICE_URL + "/master/wagonbyrakename",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function getWagonMaintenanceList(queryparams = null) {
  return await WagonMaintenanceService.getWagonMaintenanceList(
    SERVICE_URL + "/wagonmaintenance",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function saveWagonMaintenanceLastComposition(postdata = null) {
  return await WagonMaintenanceService.saveWagonMaintenanceLastComposition(
    SERVICE_URL + "/wagonmaintenance/lastcomposition",
    postdata,
    CONFIG_HEADERS
  );
}
export async function saveWagonMaintenanceCurrentComposition(postdata = null) {
  return await WagonMaintenanceService.saveWagonMaintenanceCurrentComposition(
    SERVICE_URL + "/wagonmaintenance/currentcomposition",
    postdata,
    CONFIG_HEADERS
  );
}
export async function validateWagonMaintenanceByRakeName (queryparams = null) {
  return await WagonMaintenanceService.validateWagonMaintenanceByRakeName(
    SERVICE_URL + "/wagonmaintenance/rakevalidate",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getLatestJobDetailsByRakeNameList (queryparams = null) {
  return await WagonMaintenanceService.getLatestJobDetailsByRakeNameList(
    SERVICE_URL + "/wagonmaintenance/getlatestjobdetailsbyrakename",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function saveScheduleMaintenance (postdata = null) {
  return await WagonMaintenanceService.saveScheduleMaintenance(
    SERVICE_URL + "/schedulemaintenance",
    postdata,
    CONFIG_HEADERS
  );
}
export async function getScheduleMaintenanceList (queryparams = null) {
  return await WagonMaintenanceService.getScheduleMaintenanceList(
    SERVICE_URL + "/schedulemaintenance",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function saveSpareScheduleMaintenance (postdata = null) {
  return await WagonMaintenanceService.saveSpareScheduleMaintenance(
    SERVICE_URL + "/spareschedulemaintenance",
    postdata,
    CONFIG_HEADERS
  );
}
export async function getSpareScheduleMaintenanceList (queryparams = null) {
  return await WagonMaintenanceService.getSpareScheduleMaintenanceList(
    SERVICE_URL + "/spareschedulemaintenance",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function insertInvoiceData(param = null) {
  return await ReportServices.insertInvoiceData(
    SERVICE_URL + "/invoicesubmission",
    param,
    CONFIG_HEADERS
  );
}
export async function getInvoiceSubmissionReport(param = null) {
  return await ReportServices.getInvoiceSubmissionReport(
    SERVICE_URL + "/invoicesubmissionreport",
    param,
    CONFIG_HEADERS
  );
}

export async function getPrevJobId(queryparams = null) {
  return await GeneralJobServices.getPrevJobId(
    SERVICE_URL + "/prevjobsearch",
    queryparams,
    CONFIG_HEADERS
  );
}

export async function CreateCreditNote(
  postdata = null,
  sapCredintials = null
) {
  CONFIG_HEADERS.sap_name_pw = await getEncodedUserPw(sapCredintials);
  return await GpwisJobservices.createJobService(
    SERVICE_URL + "/sap/createCreditNote",
    postdata,
    CONFIG_HEADERS
  );
}

export async function CancelCreditNote(postdata = null) {
  return await SftoJobservices.createJobService(
    SERVICE_URL + "/cancelCreditNote",
    postdata,
    CONFIG_HEADERS
  );
}
export async function CreateGPWISCreditNote(
  postdata = null,
  sapCredintials = null
) {
  CONFIG_HEADERS.sap_name_pw = await getEncodedUserPw(sapCredintials);
  return await GpwisJobservices.createJobService(
    SERVICE_URL + "/sap/createGPWISCreditNote",
    postdata,
    CONFIG_HEADERS
  );
}

export async function downloadConsolidatedPDFReport(postedData, fileName) {
  return await ReportServices.downloadConsolidatedPDFReport(
    SERVICE_URL + "/printannexurepdf",
    CONFIG_HEADERS,
    postedData,
    "Consolidated Invoice"
  );
}

// Consolidated Invoice APIs MGT
export async function getConsolidatedDataMGT(param = null) {
  return await ReportServices.getConsolidatedDataMGT(
    SERVICE_URL + "/consolidatedinvoicemgt",
    param,
    CONFIG_HEADERS
  );
}

// SFTO Reconciliation Modules
export async function getSFTOReconciliationMainDetails(queryparams = null) {
  return await SFTOReconciliationServices.getSFTOReconciliationMainDetails(
    SERVICE_URL + "/sfto/reconciliation",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function insertSFTOReconciliationMainDetails(postdata = null) {
  return await SFTOReconciliationServices.inserSFTOReconciliationDetails(
    SERVICE_URL + "/sfto/reconciliation",
    postdata,
    CONFIG_HEADERS
  );
}
export async function getSFTOReconciliationCompletedDetails(
  queryparams = null
) {
  return await SFTOReconciliationServices.getSFTOReconciliationCompletedDetails(
    SERVICE_URL + "/sfto/completedreconciliation",
    queryparams,
    CONFIG_HEADERS
  );
}
export async function getSFTOReconciliationTmillDetails(postdata = null) {
  return await SFTOReconciliationServices.getSFTOReconciliationTmillDetails(
    SERVICE_URL + "/sfto/reconciliation/tmill",
    postdata,
    CONFIG_HEADERS
  );
}
export async function inserSFTOReconciliationDetailsTmill(postdata = null) {
  return await SFTOReconciliationServices.inserSFTOReconciliationDetails(
    SERVICE_URL + "/sfto/reconciliation/tmill",
    postdata,
    CONFIG_HEADERS
  );
}
export async function getSFTOReconciliationCustomerDetails(postdata = null) {
  return await SFTOReconciliationServices.getSFTOReconciliationCustomerDetails(
    SERVICE_URL + "/sfto/reconciliation/customer",
    postdata,
    CONFIG_HEADERS
  );
}
export async function inserSFTOReconciliationDetailsCustomer(postdata = null) {
  return await SFTOReconciliationServices.inserSFTOReconciliationDetailsCustomer(
    SERVICE_URL + "/sfto/reconciliation/customer",
    postdata,
    CONFIG_HEADERS
  );
}
export async function getSFTOReconciliationInsuranceDetails(postdata = null) {
  return await SFTOReconciliationServices.getSFTOReconciliationInsuranceDetails(
    SERVICE_URL + "/sfto/reconciliation/ir",
    postdata,
    CONFIG_HEADERS
  );
}
export async function inserSFTOReconciliationDetailsInsurance(postdata = null) {
  return await SFTOReconciliationServices.inserSFTOReconciliationDetailsInsurance(
    SERVICE_URL + "/sfto/reconciliation/ir",
    postdata,
    CONFIG_HEADERS
  );
}
export async function getSFTOReconciliationRailwaysDetails(postdata = null) {
  return await SFTOReconciliationServices.getSFTOReconciliationRailwaysDetails(
    SERVICE_URL + "/sfto/reconciliation/ir",
    postdata,
    CONFIG_HEADERS
  );
}
export async function inserSFTOReconciliationDetailsRailways(postdata = null) {
  return await SFTOReconciliationServices.inserSFTOReconciliationDetailsRailways(
    SERVICE_URL + "/sfto/reconciliation/ir",
    postdata,
    CONFIG_HEADERS
  );
}
export async function getReconciliationMaster(postdata = null) {
  return await SFTOReconciliationServices.getReconciliationMaster(
    SERVICE_URL + "/sfto/completedreconciliation",
    postdata,
    CONFIG_HEADERS
  );
}

export async function Mergepdfs(postedData, fileName) {
  return await ReportServices.Mergepdfs(
    SERVICE_URL + "/mergepdfs",
    CONFIG_HEADERS,
    postedData,
    fileName
  );
}

export async function getBPCNo (queryparams = null) {
  return await WagonMaintenanceService.getBPCNo(
    SERVICE_URL + "/getbpc",
    queryparams,
    CONFIG_HEADERS
  );
}

// Eproc Pending Invoice -
export async function getPendingInvoiceList(param = null) {
  return await ReportServices.getPendingInvoiceList(
    SERVICE_URL + "/invoicesubmission",
    param,
    CONFIG_HEADERS
  );
}

export async function insertNonLobData(param = null) {
  return await ReportServices.insertNonLobData(
    SERVICE_URL + "/invoicesubmissionreport",
    param,
    CONFIG_HEADERS
  );
}
export async function insertNonLobFile(param = null) {
  return await ReportServices.insertNonLobFile(
    SERVICE_URL + "/invoicesubmissionreport",
    param,
    CONFIG_HEADERS
  );
}

let exportObj = {
  testSendingMail,
  downloadConsolidatedInvoiceDetails,
  downloadMgtInvoiceDetails,
  getConsolidatedInvoiceOptions,
  consolidatedInvoiceSapTransaction,
  getExecutiveDashboardData,
  filterMonthlyOrDailyReport,
  getLobDataForDefaultData,
  getConsolidatedData,
  postMonthlyOrDailyReport,
  getMonthlyOrDailyReport,
  listDsr,
  listCustomers,
  getUserToken,
  listCommonDropdownValues,
  listOriginDestinations,
  listGpwisStatus,
  listSftoActiveRakes,
  listGpwisActiveRakes,
  gpwisCustomerWolist,
  gpwisCircuitlist,
  gpwisCreateJob,
  jobInvoiceDetails,
  commodityList,
  shipToPartyMastersList,
  searchGpwisJoblist,
  downloadDsrReport,
  activeGpwisJobsList,
  gpwisCustomerJobsList,
  SftoCustomerWolist,
  SftoCustomerWoDetails,
  ShipToPartyDetails,
  VendorDetails,
  POVendorDetails,
  SftoCustomerWoRouteDetails,
  SftoRoutelist,
  SftoRakeDetails,
  circuitCyleActiveJobs,
  sftoCreateJob,
  sftojobheaderdetails,
  sendEmail,
  gpwisSaveJobRakeDetails,
  sftojobheaderdetailsbyjobid,
  activeJobsList,
  approveGpwisJob,
  gpwisJobRakedetails,
  gpwisSaveJobRRDetails,
  sftoJobOriginDetailsSave,
  sftoOriginDetailsbyjobid,
  approveSftoJob,
  gpwisSaveJobLoadingDetails,
  getGpwisJobLoadingDetails,
  getGpwisJobHeader,
  gpwisSaveJobUnloadingDetails,
  getGpwisJobUnloadingDetails,
  getSftoIntermediateStations,
  getSftoRouteslist,
  saveRoute,
  saveMastersRoute,
  saveSftoLoadingPoints,
  getSftoLoadingPoints,
  sftoWagonExcelParse,
  sftoCalculateFee,
  rakeWagonList,
  saveSftoWagondetails,
  getSftoWagondetails,
  saveSftoRRdetails,
  getSftoRRdetails,
  saveSftoRROtherdetails,
  getSftoRROtherdetails,
  saveSftoRouteFinalisationdetails,
  getSftoRouteFinalisationdetails,
  saveSftoIntransitdetails,
  getSftoIntransitdetails,
  getSftoDestinationdetails,
  saveSftoDestinationdetails,
  saveSftoReturndetails,
  getSftoReturndetails,
  activeJobdetails,
  searchDamageWagonlist,

  saveSftoCommercialDetails,
  generateSftoPackinglist,
  getLiveRakesList,
  getRakesList,
  generateSftoDestinationmemo,
  saveWagonMaster,

  searchWagonMasterlist,
  saveDamageWagon,
  saveRakeMaintenance,
  searchRakeMaintenance,
  getSpareWagonCommissioning,
  getSpareWagonDelivery,
  getQuotationFromSupplier,
  saveQuotaionFromSupplier,
  searchQuotationFromSupplier,
  savePOToSupplier,
  searchPOToSupplier,
  saveInspectionAgency,
  searchInspectionAgency,
  saveDeliveryConfirmation,
  getDeliveryConfirmation,
  saveRakeManufacturing,
  searchRakeManufacturing,
  getCreditlimitCheckDetails,
  createProformaInvoice,
  saveRakeCommissioning,
  searchRakeCommissioning,
  getRakeMaintenanceDetails,
  saveSpareWagonDelivery,
  saveSpareWagonCommissioning,
  createSFTOIO,
  createGPWISIO,
  saveSapDefaults,
  getSapDefaults,
  saveContractAdvanceDetails,
  getContractAdvanceDetails,
  getContractDetails,
  getContractStationsDetails,
  createSFTOSO,
  getLiveRakeGpsDetails,
  saveRakeMaster,
  saveRouteMasterHeader,
  saveRouteMasterDetails,
  searchRouteMaster,
  searchRakeMaster,
  updateSFTOSO,
  createSFTOPO,
  createGPWISSO,
  createInvoice,
  generateLoadNo,
  getRouteMasterDivisionDetails,
  getMastersRoutes,
  getRouteMasterDetails,
  updateGPWISSO,
  createGPWISInvoice,
  dmsFileUpload,
  dmsFileDelete,
  getoriginslist,
  getdestinationslist,
  getGPSCoordinates,
  getRakesListByCustomerName,
  getDashboardInvoiceDetails,
  savedashboardinvoicedetails,
  getGPWISInvoiceDetailsBasedOnJob,
  getSFTOInvoiceDetailsBasedOnJob,
  getDashboardSFTOJobDetails,
  getDashboardGPWISJobDetails,
  downloadDashboardJobDetails,
  downloadDashboardGpwisJobDetails,
  downloadDashboardReports,
  downloadIdelWeightReports,
  downloadDetentionDashboardReports,
  getCustomerRefNumber,
  saveJobDetailsForThresholdLogic,
  saveThresholdLogicQuantity,
  getThresholdRemainingAmountbyCustomerRefNumber,
  contractHeaderlist,
  getcontractHeaderlist,
  savecontractHeader,
  vendorMasterHeaderlist,
  savevendorMasterHeader,
  saveShipToPartyMaster,
  deletecontractLineItem,
  getContractNoList,
  getCustomerList,
  getVendorList,
  getDashboardSFTOReports,
  getDashboardGPWISReports,
  uploadExcellForContractMaster,
  getDashboardData,
  getDashboardStatusDetails,
  contractMasterExcelDownload,
  saveCommodityMaster,
  commodityMasterDetails,
  rakeDetentionReports,
  tonnageReports,
  idelWeightReports,
  getThresholdMasterlist,
  saveCustomerThreholdValue,
  getCustomerThresholdDetails,
  getCustomerRefDetails,
  tripWiseProfitabilityReport,
  downloadTripWiseProfitabilityReports,
  createSAPIO,
  createSAPSO,
  createSAPInvoie,
  createGPWISSAPSO,
  getSftoJobDeatilsReport,
  downloadSftoJobDetailsReports,
  getGpwisJobDeatilsReport,
  downloadGpwisJobDetailsReports,
  calculateRebate,
  getgpwrsdata,
  rebatesummaryreport,
  getgpwrsdistance,
  getRRDetailsfromDoc,
  getMaterialClassMasterList,
  saveMaterialClassMaster,
  getFrieghtsMasterList,
  saveFrieghtsMaster,
  getUniqueWagonTypeList,
  getRakeMasterList,
  saveRakeRebateMaster,
  getInvoiceSftoDeatilsReport,
  getInvoiceGpwisDeatilsReport,
  downloadSftoInvoiceDetailsReports,
  downloadGpwisInvoiceDetailsReports,
  getODMasterList,
  saveODMaster,
  userLogout,
  getTATReconciliationMasterTransactorList,
  saveTATReconciliationMaster,
  getInvoiceReportDetails,
  getTATReportList,
  getTATReport,
  getRevenueReportList,
  getRevenueReport,
  getRakeRebateReportData,
  resetLogin,
  createRekRebateSO,
  createRekRebateInvoice,
  getClientDetails,
  saveSftoContractdetails,
  getStationMasterList,
  sftoUpdateJob,
  createStationMasterList,
  stationMasterExcelDownload,
  wagonComponentMasterExcelDownload,
  wagonMasterListByRakeName,
  cancelInvoiceDetails,
  saveExaminationTypeMaster,
  getExaminationTypeMasterList,
  saveDepoMaster,
  getDepoMasterList,
  saveWagonComponentMaster,
  getWagonComponentMasterList,
  saveRohPohScheduleMaster,
  getRohPohScheduleMasterList,
  getBPCDetailsfromDoc,
  getWagonMaintenanceList,
  saveWagonMaintenanceLastComposition,
  saveWagonMaintenanceCurrentComposition,
  validateWagonMaintenanceByRakeName,
  getLatestJobDetailsByRakeNameList,
  saveScheduleMaintenance,
  getScheduleMaintenanceList,
  saveSpareScheduleMaintenance,
  getSpareScheduleMaintenanceList,
  uploadExcellForWagonMaster,
  getInvoiceList,
  insertInvoiceData,
  getInvoiceSubmissionReport,
  getPrevJobId,
  CreateCreditNote,
  CancelCreditNote,
  getSFTOReconciliationMainDetails,
  insertSFTOReconciliationMainDetails,
  getSFTOReconciliationCompletedDetails,
  getSFTOReconciliationTmillDetails,
  inserSFTOReconciliationDetailsTmill,
  getSFTOReconciliationCustomerDetails,
  inserSFTOReconciliationDetailsCustomer,
  getSFTOReconciliationInsuranceDetails,
  inserSFTOReconciliationDetailsInsurance,
  getSFTOReconciliationRailwaysDetails,
  inserSFTOReconciliationDetailsRailways,
  CreateGPWISCreditNote,
  getConsolidatedDataMGT,
  downloadConsolidatedPDFReport,
  Mergepdfs,
  getBPCNo,
  getPendingInvoiceList,
  getReconciliationMaster,
  insertNonLobData,
  insertNonLobFile,
};

export default exportObj;
